module.exports = __webpack_public_path__ + "img/heart.07cfbb8.png";